import { uploadStats, useUploads, type UploadItem } from '../../store/uploads.ts';
import { formatBytes } from '../../lib/format.ts';
import { IconCheck, IconChevronDown, IconClose } from '../../lib/icons.tsx';

const STATE_LABEL: Record<UploadItem['state'], string> = {
  queued: '대기 중', hashing: '해시 계산 중', uploading: '업로드 중',
  committing: '마무리 중', done: '완료', error: '실패', canceled: '취소됨',
};

export function UploadPanel() {
  const items = useUploads((s) => s.items);
  const open = useUploads((s) => s.open);
  const setOpen = useUploads((s) => s.setOpen);
  const cancel = useUploads((s) => s.cancel);
  const retry = useUploads((s) => s.retry);
  const clearFinished = useUploads((s) => s.clearFinished);

  if (items.length === 0) return null;
  const stats = uploadStats(items);

  return (
    <section className="uploads" aria-label="업로드 진행 상황">
      <header className="uploads__head">
        <span className="spacer">
          {stats.active > 0
            ? `업로드 중 ${stats.done}/${stats.total} · ${Math.round(stats.progress * 100)}%`
            : `업로드 완료 ${stats.done}/${stats.total}${stats.failed ? ` · 실패 ${stats.failed}` : ''}`}
        </span>
        {stats.active === 0 && (
          <button className="btn btn--sm btn--ghost" onClick={clearFinished}>지우기</button>
        )}
        <button
          className="btn btn--sm btn--ghost btn--icon"
          aria-label={open ? '접기' : '펼치기'}
          onClick={() => { setOpen(!open); }}
        >
          <IconChevronDown size={16} style={{ transform: open ? 'none' : 'rotate(180deg)' }} />
        </button>
      </header>

      {open && (
        <div className="uploads__list">
          {items.map((item) => (
            <div key={item.id} className="uitem" data-state={item.state}>
              <div className="uitem__top">
                <span className="truncate spacer" title={item.targetPath}>{item.name}</span>
                {item.state === 'done' && <IconCheck size={14} />}
                {item.state === 'error' && (
                  <button className="btn btn--sm btn--ghost" onClick={() => { retry(item.id); }}>
                    재시도
                  </button>
                )}
                {(item.state === 'queued' || item.state === 'hashing'
                  || item.state === 'uploading') && (
                  <button
                    className="btn btn--sm btn--ghost btn--icon"
                    aria-label="취소"
                    onClick={() => { cancel(item.id); }}
                  >
                    <IconClose size={14} />
                  </button>
                )}
              </div>
              <div className="uitem__bar">
                <div className="uitem__fill" style={{ width: `${item.progress * 100}%` }} />
              </div>
              <div className="uitem__meta">
                {item.error ?? `${STATE_LABEL[item.state]} · ${formatBytes(item.size)}`}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
